<template>
	<div class="wp100 oh">
		<!-- 头部 -->
		<div class="disf jc-s ai-c pl10 mb5" style="height: 32px;">
			<p><i class="fs16 sz szfuzhubian mr5" style="color: #909399"></i>杂志主编</p>
			<div>
			</div>
		</div>
		
		<div class="wp100 bg-c-fff p10" style="overflow-y: auto;height: calc(100vh - 125px);">
			<div class="wp100" v-html="introContent">
				
			</div>
		</div>

	</div>
</template>


<script>
export default {
	data(){
		return {
			introContent: `<p style='text-align: center;'></p>`
		}
	},
	
	mounted(){
			this.$api.magazine.getIntro().then((res) => {
				if(res.Status == 1){
					this.introContent = res.Data.intro;
				}else{
					this.alertError("加载失败，请刷新重试", 1200);
				}
			}).catch((err) => {
				this.alertError("加载失败，请刷新重试", 1200);
			})
	},
}
</script>

<style lang="scss" scoped>
	.ql-align-center {
		text-align: center !important;
	}
	// .box {
	// 	background-color: white;
	// 	border: 1rpx solid #efefef;
	// }

	// .time {
	// 	font-size: 13px;
	// 	color: #999;
	// }

	// .bottom {
	// 	margin-top: 13px;
	// 	line-height: 12px;
	// }

	// .button {
	// 	padding: 0;
	// 	float: right;
	// }

	// .image {
	// 	width: 300px;
	// 	display: block;
	// }



	// .chooseSource {
	// 	border-bottom: 2px solid #f93e61;
	// 	color: #f93e61;
	// }

	// .stateNum {
	// 	background-color: #f93e61;
	// }

	// .flex {
	// 	flex: 1;
	// 	width: 33%;
	// 	min-width: 100%;
	// 	max-width: 100%;
	// }

	// .zazhi {
	// 	display: flex;
	// 	flex-wrap: wrap;
	// }

	// .common-shadow {
	// 	border: 1px solid #e4e7ed;
	// 	box-shadow: 0px 1px 15px 1px rgba(0, 0, 0, 0.1);
	// }
</style>
